import { motion } from "framer-motion";
import Marquee from "react-fast-marquee";
import { Building2, Microscope, Languages } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";

/* Klinik bandi — dergi usulu (bordo/altin) editoryal gorseller, saga dogru kendiliginden kayan serit. */
const CLINIC_SHOTS = ["/img/clinic/c1.jpg", "/img/clinic/c2.jpg", "/img/clinic/c3.jpg", "/img/clinic/c4.jpg", "/img/clinic/c5.jpg"];

export function ClinicBand() {
  const { t } = useLang();

  const chips = [
    { icon: Building2, label: t("clinic_chip1") },
    { icon: Microscope, label: t("clinic_chip2") },
    { icon: Languages, label: t("clinic_chip3") },
  ];

  return (
    <section className="relative overflow-hidden bg-[linear-gradient(155deg,#16040a_0%,#331020_55%,#16040a_100%)]" data-testid="clinic-band">
      <span aria-hidden className="absolute -right-8 -top-6 font-magserif text-[18vw] leading-none text-[#C9A96A] opacity-[0.06] select-none pointer-events-none hidden lg:block">医</span>
      <div className="relative max-w-7xl mx-auto px-6 pt-24 sm:pt-32 pb-14">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="max-w-2xl"
        >
          <div className="flex items-center gap-3 mb-5">
            <span className="h-px w-10 bg-[#C9A96A]/60" />
            <span className="text-[11px] font-heading font-bold tracking-[0.18em] sm:tracking-[0.3em] uppercase text-[#C9A96A]">{t("clinic_kicker")}</span>
          </div>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-[#F5EFE6] text-balance">{t("clinic_title")}</h2>
          <p className="mt-6 text-base sm:text-lg text-[#E8DCC8]/70 leading-relaxed max-w-xl">{t("clinic_sub")}</p>
          <div className="mt-9 flex flex-wrap gap-3">
            {chips.map((c, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 12 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.15 + i * 0.1 }}
                className="flex items-center gap-2 px-4 py-2.5 rounded-full bg-white/5 backdrop-blur-md border border-[#C9A96A]/25 text-[#F5EFE6] text-xs font-semibold"
              >
                <c.icon size={14} className="text-[#C9A96A]" /> {c.label}
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1, delay: 0.2 }}
        className="relative pb-24 sm:pb-32"
        data-testid="clinic-marquee"
      >
        <Marquee speed={35} direction="right" gradient={false} pauseOnHover>
          {CLINIC_SHOTS.map((src, i) => (
            <div key={src} className="mx-3 rounded-2xl p-[2px] bg-[linear-gradient(140deg,#C9A96A_0%,#6e5522_45%,#C9A96A_65%,#8a6b2f_100%)] shadow-[0_24px_50px_-18px_rgba(0,0,0,0.7)]">
              <img
                src={src}
                alt=""
                data-testid={i === 0 ? "clinic-image" : `clinic-image-${i + 1}`}
                className="h-56 sm:h-72 w-auto rounded-[calc(1rem-2px)] object-cover select-none"
                loading="lazy"
                draggable={false}
              />
            </div>
          ))}
        </Marquee>
      </motion.div>
    </section>
  );
}
